import { Box, Typography } from '@material-ui/core'
import { InfoWindow } from '@react-google-maps/api'
import React from 'react'

function GoogleMapInfo({ googleInfo }) {
    return (
        <div>
            {googleInfo?.map((info) => (
                <InfoWindow
                    key={`info-${info.data.id}`}
                    position={{
                        lat: parseFloat(info.data.latitude) || 0,
                        lng: parseFloat(info.data.longitude) || 0
                    }}
                    options={{
                        disableAutoPan: false,
                        pixelOffset: new window.google.maps.Size(0, -23) // Adjusts position above marker
                    }}
                    onCloseClick={() => info.setter(null)}
                >
                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: 2,
                            p: 2,
                            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                            minWidth: info.isCandidate ? 220 : 200,
                            maxWidth: info.isCandidate ? 280 : 260,
                            fontFamily: "Roboto, sans-serif",
                            textAlign: "left",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                color: info.isCandidate ? "#1976d2" : "#1E3A8A",
                                mb: 1,
                                borderBottom: info.isCandidate ? "none" : "2px solid #E0E7FF",
                                pb: info.isCandidate ? 0 : 0.5,
                            }}
                        >
                            {info.isCandidate ? `👤 ${info.data.name}` : `🏢 ${info.data.name || "N/A"}`}
                        </Typography>

                        {info.isCandidate ? (
                            <>
                                {info.data.email && (
                                    <Typography variant="body2" sx={{ color: "#374151", mb: 0.5, display: "flex", alignItems: "center" }}>
                                        📧 <span style={{ marginLeft: 6 }}>{info.data.email}</span>
                                    </Typography>
                                )}
                                {info.data.contact_number && (
                                    <Typography variant="body2" sx={{ color: "#374151", mb: 1, display: "flex", alignItems: "center" }}>
                                        📞 <span style={{ marginLeft: 6 }}>{info.data.contact_number}</span>
                                    </Typography>
                                )}
                                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 1 }}>
                                    <a
                                        href={`/admin/candidate/${info.data.id}/detail`}
                                        style={{
                                            backgroundColor: "#1976d2",
                                            color: "#fff",
                                            textDecoration: "none",
                                            padding: "6px 14px",
                                            borderRadius: "8px",
                                            fontWeight: 600,
                                            fontSize: "0.9rem",
                                            transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#115293")}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#1976d2")}
                                    >
                                        View Profile →
                                    </a>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Typography variant="body1" sx={{ color: "#374151", fontWeight: 500, mb: 0.5 }}>
                                    Customer: <span style={{ color: "#111827", fontWeight: 600 }}>{info.data.customer_name || "N/A"}</span>
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#4B5563", fontWeight: 500 }}>
                                    Total: <span style={{ color: "#2563EB", fontWeight: 700 }}>{info.data.total || 0}</span>
                                </Typography>
                            </>
                        )}
                    </Box>
                </InfoWindow>
            ))}

        </div>
    )
}

export default GoogleMapInfo
